import axios from "axios";

export default {
    state: () => ({
        additionalServiceList : null,
        additionalServicePriceList : null,
        additionalServicePricingTemplateList : null,
        additionalServicePricingTemplate : null,
        additionalServicePricingPeriodList : null
    }),
    mutations: {
        setAdditionalServiceList:function (state, additionalServiceList){
            state.additionalServiceList = additionalServiceList;
        },
        setAdditionalServicePriceList:function (state, additionalServicePriceList){
            state.additionalServicePriceList = additionalServicePriceList;
        },
        setAdditionalServicePricingTemplateList:function (state, additionalServicePricingTemplateList){
            state.additionalServicePricingTemplateList = additionalServicePricingTemplateList;
        },
        setAdditionalServicePricingTemplate:function (state, additionalServicePricingTemplate){
            state.additionalServicePricingTemplate = additionalServicePricingTemplate;
        },
        setAdditionalServicePricingPeriodList:function (state, additionalServicePricingPeriodList){
            state.additionalServicePricingPeriodList = additionalServicePricingPeriodList;
        },
    },
    getters: {
        getAdditionalServiceList : state => {
            return state.additionalServiceList
        },
        getAdditionalServicePriceList : state => {
            return state.additionalServicePriceList
        },
        getAdditionalServicePricingTemplateList : state => {
            return state.additionalServicePricingTemplateList
        },
        getAdditionalServicePricingTemplate : state => {
            return state.additionalServicePricingTemplate
        },
        getAdditionalServicePricingPeriodList : state => {
            return state.additionalServicePricingPeriodList
        },
    },
    actions:{
        loadAdditionalServiceList(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(
                context.getters.getServiceUrl + "/admin-api/additional-service",{headers})
                .then((response) => {
                    context.commit("setAdditionalServiceList", response.data);
                    return response.data;
                })
        },
        loadAdditionalServicePricesListByTemplateId(context, {templateId}){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(
                context.getters.getServiceUrl + "/admin-api/additional-service/price/byTemplateId/"+templateId,{headers})
                .then((response) => {
                    context.commit("setAdditionalServicePriceList", response.data);
                    return response.data;
                })
        },
        loadAdditionalServicePricingTemplateList(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/additional-service/pricing-template",{headers})
                .then((response) => {
                    context.commit("setAdditionalServicePricingTemplateList", response.data)
                    return response.data;
                })
        },
        updateAdditionalServicePricingTemplate(context, template){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.put(context.getters.getServiceUrl + "/admin-api/additional-service/pricing-template", template,{headers})
                .then((response) => {
                    return response.data;
                })
        },
        loadAdditionalServicePricingTemplate(context, {id}){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/additional-service/pricing-template/"+id,{headers})
                .then((response) => {
                    context.commit("setAdditionalServicePricingTemplate", response.data)
                    return response.data;
                })
        },
        loadAdditionalServicePricingPeriodList(context, pricingTemplateId){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/additional-service/pricing-template/"+pricingTemplateId+"/pricing-periods",{headers})
                .then((response) => {
                    context.commit("setAdditionalServicePricingPeriodList", response.data)

                    return response.data;
                });
        },
        createAdditionalServicePricingPeriod(context, pricingPeriod){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/additional-service/pricing-template/pricing-periods", pricingPeriod,{headers})
                .then((response) => {
                    return response.data;
                })
        },
        deleteAdditionalServicePricingPeriod(context, pricingPeriodId){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.delete(context.getters.getServiceUrl + "/admin-api/additional-service/pricing-template/pricing-periods/"+pricingPeriodId,{headers});
        },
        updateAdditionalServicePricingPeriod(context, pricingPeriod){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.put(context.getters.getServiceUrl + "/admin-api/additional-service/pricing-template/pricing-periods", pricingPeriod,{headers})
                .then((response) => {
                    return response.data;
                })
        },
        createOrUpdateAdditionalServicePrices(context, prices){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.put(context.getters.getServiceUrl + "/admin-api/additional-service/price/createOrUpdate", prices,{headers})
                .then((response) => {
                    return response.data;
                })
        },
    }
}